import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@app/services/User/user.service';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate  {
    constructor(
        private router: Router,
        private accountService: UserService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        //user?.token, const user = this.accountService.userValue; TODO -local storage user 
        if (sessionStorage.getItem('token')) {
            // Authorised so return true
            return true;
        }
        else {
            // Not logged in so redirect to login page with the return url
            //this.router.navigate(['/'], { queryParams: { returnUrl: state.url }});
            this.router.navigate(['/login']);
            return false;
        }
    }
}